import React from "react";
import { altColor } from "../../utils/constants";

const EmailAt = ({ color = altColor }) => (
  <svg
    version="1.1"
    id="Design_here"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    style={{ enableBackground: "new 0 0 24 24" }}
    xmlSpace="preserve"
    width="21"
    height="21"
  >
    <path
      d="M14.064,2.207c-3.259-0.656-6.498,0.25-8.889,2.482c-2.39,2.231-3.515,5.386-3.088,8.654c0.576,4.4,4.189,8.005,8.592,8.571
      c0.434,0.056,0.867,0.083,1.299,0.083c2.463,0,4.846-0.896,6.688-2.545l-1.334-1.49c-1.758,1.572-4.03,2.272-6.398,1.968
      C7.418,19.479,4.531,16.6,4.07,13.084c-0.342-2.62,0.559-5.146,2.471-6.933c1.913-1.786,4.514-2.509,7.129-1.983
      c4.046,0.813,6.743,4.64,6.276,8.9C19.771,14.664,18.285,15,18,15c-0.534,0-0.751-0.173-0.868-0.304
      c-0.656-0.733-0.431-2.765-0.296-3.978c0.037-0.333,0.07-0.636,0.088-0.889c0.064-0.928-0.505-1.771-1.385-2.049
      c-0.151-0.048-0.317-0.104-0.494-0.166c-1.581-0.541-4.526-1.55-6.752,0.678c-1.415,1.415-2.331,3.867-1.188,6.154
      C8.382,17,10.917,17,12,17c1.281,0,2.442-0.459,3.375-1.314c0.08,0.12,0.169,0.235,0.267,0.345
      C16.038,16.473,16.769,17,18,17c1.422,0,3.656-1.18,3.935-3.713C22.516,7.989,19.132,3.226,14.064,2.207z M14.848,10.498
      c-0.1,0.901-0.219,1.975-0.138,2.995l-0.057-0.037C13.989,14.48,13.097,15,12,15c-1.205,0-2.438-0.111-3.105-1.447
      c-0.798-1.596,0.135-3.168,0.812-3.846c0.587-0.586,1.256-0.804,1.991-0.804c0.824,0,1.731,0.273,2.699,0.604
      c0.192,0.066,0.373,0.128,0.53,0.184C14.912,9.921,14.882,10.195,14.848,10.498z"
      fill={color}
      strokeWidth="0.5"
    />
  </svg>
);

export default EmailAt;
